import { Component, input } from '@angular/core';
import { BaseComponent } from '@shared/classes';
import { RewardStickerComponent } from '@shared/components/challenges/elements/reward-sticker/reward-sticker.component';
import { LimitsPerNbSteps } from '@shared/constants';
import { StepChallenge } from '@shared/factory';
import { StepChallengeVariant4Config } from '@shared/models';
import {
  AmountPipe,
  ProgressWidthPipe,
  StepStatusPipe,
  VariableReplacementPipe,
} from '@shared/pipes';

@Component({
  selector: 'b2c-progress-section',
  templateUrl: './progress-section.component.html',
  styleUrl: './progress-section.component.scss',
  imports: [
    AmountPipe,
    StepStatusPipe,
    ProgressWidthPipe,
    RewardStickerComponent,
    VariableReplacementPipe,
  ],
})
export class ProgressSectionComponent extends BaseComponent {
  challenge = input.required<StepChallenge>();
  config = input.required<StepChallengeVariant4Config>();

  // Pixels along the 165px bar at which each step dot sits: the centres of the
  // 50px steps spread across it.
  public limitsPerNbSteps: LimitsPerNbSteps = {
    oneStep: { start: 0, end: 140 },
    twoStep: {
      step1: { start: 0, end: 25 },
      step2: { start: 25, end: 140 },
    },
    threeStep: {
      step1: { start: 0, end: 25 },
      step2: { start: 25, end: 82.5 },
      step3: { start: 82.5, end: 140 },
    },
  };
}
